/**
 * SEO effects for Calculator page
 * Delegates to useSEO hook for consistent DOM management and cleanup
 */
import { useSEO } from '../../../shared/hooks/useSEO';
import { generateSeoTitle, generateSeoDescription } from '../../../utils/seoUrlUtils';
import type { OSDCode } from '../../../types/osd.types';
import type { OSDCode as OSDMetaCode } from '../../../utils/osdMetadata';
import type { TariffType } from '../types/calculator.types';

interface UseCalculatorSEOProps {
  urlOSD: OSDCode | null;
  urlTariff: TariffType | null;
  selectedOSD: OSDCode;
  currentTariff: TariffType;
}

/**
 * Custom hook to manage SEO for Calculator page
 *
 * Canonical path follows the route structure: /{OSD}/kalkulatory/podstawowy[/{tariff}]
 */
export function useCalculatorSEO({
  urlOSD,
  urlTariff,
  selectedOSD,
  currentTariff,
}: UseCalculatorSEOProps) {
  const effectiveOSD = urlOSD || (selectedOSD as OSDMetaCode);
  const effectiveTariff = urlTariff || (currentTariff as any);

  const title = generateSeoTitle(effectiveOSD, effectiveTariff);
  const description = generateSeoDescription(effectiveOSD, effectiveTariff);

  // Canonical path matches route structure: /:osd/kalkulatory/podstawowy[/:tariff]
  let canonicalPath = `/${selectedOSD}/kalkulatory/podstawowy`;
  if (urlTariff && urlTariff !== 'G11') {
    canonicalPath += `/${urlTariff}`;
  }

  useSEO({ title, description, canonicalPath });
}
